module.exports = __webpack_public_path__ + "static/media/faq_(8).4d9a5c2f.gif";